import { login } from '@dvag/dfs-orchestrator-client/messengers';

import { getMonitoring } from './getMonitoring';

let isHandlingInvalidToken = false;

export const handleInvalidToken = () => {
  if (isHandlingInvalidToken) {
    return;
  }

  isHandlingInvalidToken = true;

  getMonitoring().trackEvent({
    name: 'auth.expired-token',
    properties: {
      level: 'warning',
    },
  });

  login();
};
